module.exports = "<s-localized-string v-bind=\"$attrs\" :value=\"value\"/>\n"